import { Season } from "../types/season";

export const getTeamStatusName = (status: Season.TeamStatus) => {
  switch (status) {
    case "check":
      return "🔍 审核中";
    case "reject":
      return "⛔️ 审核未通过";
    case "pass":
      return "✅ 报名成功";
    default:
      return "未知状态";
  }
};

export const getTaskTypeName = (type: Season.TaskType) => {
  switch (type) {
    case "learn_page":
      return "学习";
    case "share_punch":
      return "打卡";
    default:
      return "未知类型";
  }
};
